module.exports = __webpack_public_path__ + "static/media/Apple Watch 40mm Gold Aluminum + Pink Sand Open.ebd7c008.png";